import { render, staticRenderFns } from "./NotesHeaderActions.vue?vue&type=template&id=6b998440&scoped=true"
import script from "./NotesHeaderActions.vue?vue&type=script&lang=js"
export * from "./NotesHeaderActions.vue?vue&type=script&lang=js"
import style0 from "./NotesHeaderActions.vue?vue&type=style&index=0&id=6b998440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b998440",
  null
  
)

export default component.exports